import { ReactElement } from "react";

interface Props {
    title: string;
    description: string;
    children: ReactElement[];
}

export default function PrivacySection({ title, description, children }: Props) {
    return (
        <div className="universaleditmodal-right-content privacy">
            <div className="universaleditmodal-right-content-text">
                <div className="universaleditmodal-right-content-text-title">
                    {title}
                </div>
                <div className="universaleditmodal-right-content-text-description">
                    {description}
                </div>
            </div>
            {children}
        </div>
    );
}
